var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8336 6.16637C14.6118 2.94454 9.3882 2.94454 6.16637 6.16637L6.16637 6.16637C2.94454 9.38818 2.94454 14.6118 6.16637 17.8336C6.23183 17.8991 6.29812 17.9632 6.36519 18.026C7.32603 16.3125 9.58792 15.25 12.0004 15.25C14.4126 15.25 16.6743 16.3123 17.6353 18.0255C17.7022 17.9629 17.7683 17.8989 17.8336 17.8336C21.0553 14.6119 21.0554 9.38857 17.834 6.16671L17.8336 6.16637ZM16.4255 18.9646C13.7342 20.6783 10.2664 20.6784 7.57502 18.965C8.10997 17.7891 9.75534 16.75 12.0004 16.75C14.2451 16.75 15.8904 17.7889 16.4255 18.9646ZM18.8943 5.10571C22.7019 8.91332 22.7019 15.0867 18.8943 18.8943C15.0867 22.7019 8.9133 22.7019 5.10571 18.8943C1.2981 15.0867 1.2981 8.9133 5.10571 5.10571C8.91332 1.2981 15.0867 1.2981 18.8943 5.10571ZM10.409 8.40901C11.2877 7.53033 12.7123 7.53033 13.591 8.40901C14.4697 9.28768 14.4697 10.7123 13.591 11.591C12.7123 12.4697 11.2877 12.4697 10.409 11.591C9.53033 10.7123 9.53033 9.28768 10.409 8.40901ZM9.34835 7.34835C10.8128 5.88388 13.1872 5.88388 14.6516 7.34835C16.1161 8.81281 16.1161 11.1872 14.6516 12.6516C13.1872 14.1161 10.8128 14.1161 9.34835 12.6516C7.88388 11.1872 7.88388 8.81281 9.34835 7.34835Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonCircle);
export default __webpack_public_path__ + "static/media/person-circle.3056c17e.svg";
export { ForwardRef as ReactComponent };